<mat-toolbar class="header">
    Users Info
    <button mat-flat-button mat-dialog-close color="mat-grey">&times;</button>
</mat-toolbar>

<div class="table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element">{{ element.index }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            style="background-color: #8aaa5c"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>

<div class="utilities-container">
    <button mat-raised-button (click)="export()">Export CSV</button>
    <mat-form-field appearance="outline">
        <mat-label>Search user...</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
            class="input-field"
            matInput
            type="text"
            (input)="onInputChange($event)"
        />
    </mat-form-field>
</div>
